import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GROUP_NAME_MAX_LENGTH } from '../../app.constants';
import { Group } from '../../models';

export type GroupDialogData = {
	mode: 'create' | 'edit';
	group?: Group;
	parentGroupName?: string;
};

export type GroupDialogResult = {
	name: string;
};

@Component({
	selector: 'app-group-dialog',
	imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule],
	templateUrl: './group-dialog.component.html',
	styleUrl: './group-dialog.component.scss'
})
export class GroupDialogComponent {
	private readonly fb = inject(FormBuilder);
	private readonly dialogRef = inject(MatDialogRef<GroupDialogComponent, GroupDialogResult>);

	data = inject<GroupDialogData>(MAT_DIALOG_DATA);

	form = this.fb.nonNullable.group({
		name: this.fb.nonNullable.control(this.data.group?.name ?? '', [
			Validators.required,
			Validators.maxLength(GROUP_NAME_MAX_LENGTH),
		]),
	});

	cancel() {
		this.dialogRef.close();
	}

	save() {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}
		this.dialogRef.close({ name: this.form.getRawValue().name });
	}
}
